import React from 'react';
import './VenueInfo.css';
import { SiGooglemaps } from "react-icons/si";

const VenueInfo: React.FC = () => {

  const address = "QUINTA DO ALFERES DE CRASTO";

  const openMaps = () => {
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps?q=${encodedAddress}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="venue-container">
      <h2 className="venue-header">Como Chegar?</h2>
      <div className="venue-content">
        <div className="venue-image">
          <img src="/venue.png" alt="Our Venue" />
        </div>
        <div className="venue-text">
          <div className="venue-icon">
            <SiGooglemaps />
          </div>
          <span className="venue-address" onClick={openMaps}>
            <p>QUINTA DO ALFERES DE CRASTO</p>
            <p>R. DO CRASTO 500</p>
            <p>4485-684</p>
            <p>VILA DO CONDE</p>
          </span>
        </div>
      </div>
    </div>
  );
};

export default VenueInfo;